import React from "react";

type ProductSelectionSheetProps = {
  open: boolean;
  priorityProducts: string[];
  selectedProduct: string;
  setSelectedProduct?: (product: string) => void;
  onClose: () => void;
};

const ProductSelectionSheet: React.FC<ProductSelectionSheetProps> = ({
  open,
  priorityProducts,
  selectedProduct,
  setSelectedProduct,
  onClose,
}) => {
  if (!open) {
    return null;
  }

  return (
    <div
      className="modal-bottom-sheet-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Escape" || e.key === "Enter") onClose();
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        tabIndex={-1}
        className="modal-bottom-sheet-content"
      >
        <div className="modal-bottom-sheet-title">Select Product</div>
        <div className="product-grid">
          {priorityProducts.map((p: string) => {
            const hasValidSelection =
              selectedProduct && priorityProducts.includes(selectedProduct);
            const isSelected =
              selectedProduct === p || (!hasValidSelection && p === "AMMONIA");

            return (
              <button
                key={p}
                type="button"
                className={`product-card ${isSelected ? "active" : ""}`}
                onClick={() => {
                  if (setSelectedProduct) {
                    setSelectedProduct(p);
                  }
                  onClose();
                }}
              >
                <span className="prod-name">
                  {p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProductSelectionSheet;
